import { Pipe, PipeTransform } from '@angular/core';
import { FEWafRuleGroupModel, WafMappedEnumList } from '@bn/app-shield';
import { FormListItem } from '@bn/web-ui/models';
import { SelectBadge, SelectItem } from '@bn/web-ui/select/models';

@Pipe({
  name: 'childRules',
  standalone: true,
  pure: false, // NOTE: fix pipe not triggering when AppShieldWafRulesPage.mainGroups enabled/disabled bug. Maybe if we use effect it would be better?
})
export class ChildRulesPipe implements PipeTransform {
  transform(ruleGroupModel: FEWafRuleGroupModel): {
    totalActive: number;
    totalLogging: number;
    total: number;
  } {
    return {
      total: ruleGroupModel.rules.length || 0,
      totalActive:
        (ruleGroupModel.rules.filter(({ isEnabled }) => !!isEnabled).length || 0) - (ruleGroupModel.rules.filter(({ isLogging }) => !!isLogging).length || 0),
      totalLogging: ruleGroupModel.rules.filter(({ isLogging }) => !!isLogging).length || 0,
    };
  }
}

@Pipe({
  name: 'mapWafEnumToSelectItems',
  standalone: true,
})
export class MapWafEnumToSelectItems implements PipeTransform {
  transform(enumList: WafMappedEnumList | undefined, isPremium: boolean): SelectItem[] {
    return (
      enumList?.enumValues?.map((enumValue) => {
        return {
          Id: Number(enumValue.value),
          Name: enumValue.name || '',
          disabled: enumValue.isPremium && !isPremium,
          badges: enumValue.isPremium
            ? ([
                {
                  context: 'info',
                  text: 'Advanced',
                  size: 'sm',
                },
              ] as SelectBadge[])
            : undefined,
        };
      }) ?? []
    );
  }
}

@Pipe({
  name: 'mapWafEnumToFormListItems',
  standalone: true,
})
export class MapWafEnumToFormListItems implements PipeTransform {
  transform(enumList: WafMappedEnumList | undefined): FormListItem[] {
    return (
      enumList?.enumValues?.map((enumValue) => {
        return {
          value: Number(enumValue.value),
          name: enumValue.name || '',
          label: enumValue.name || '',
        };
      }) ?? []
    );
  }
}

@Pipe({
  name: 'mapWafValuesToSelectItems',
  standalone: true,
})
export class MapWafValuesToSelectItems implements PipeTransform {
  transform(values: string[] | null | undefined, currentValue?: string | null): SelectItem[] {
    const items = (values ?? []).map((value) => ({ Id: value, Name: value }));

    if (currentValue && !items.some((item) => item.Id === currentValue)) {
      items.push({ Id: currentValue, Name: currentValue });
    }

    return items;
  }
}

@Pipe({
  name: 'mapArrayOfStringsToSelectItems',
  standalone: true,
})
export class MapArrayOfStringsToSelectItemsPipe implements PipeTransform {
  transform(array: string[], selectedItemsArray: string[]): SelectItem[] {
    return (
      array.map((value) => {
        return {
          Id: value,
          Name: value || '',
          disabled: selectedItemsArray.length === 1 && selectedItemsArray.indexOf(value) > -1,
        };
      }) ?? []
    );
  }
}
